/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Grid, Typography } from "@material-ui/core";
import { ChevronRight } from "@material-ui/icons";
import clsx from "clsx";
import useText from "constants/text";
import { BoxesIcon, BoxNewIcon, DashIcon, FidelityMenuIcon, GiftIcon, HistoryIcon } from "icons";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "styled-components/macro";
import { MenuItem, useStyles } from "./styles";

interface GroupMenuProps {
  icon?: React.ReactElement;
  title?: string;
  active?: boolean;
  onMouseEnter?: any;
  onMouseLeave?: any;

  isFidelity?: boolean;
}

export const GroupMenu = ({ active, icon, title, onMouseEnter, onMouseLeave, isFidelity }: GroupMenuProps) => {
  const classes = useStyles();

  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={clsx(isFidelity ? classes.fildelyMenu : classes.menuItem)}
    >
      <div className={classes.navContentMenu}>
        {icon}
        <Typography variant="h6" className={clsx(active ? classes.activeText : classes.inActiveText)}>
          {title}
        </Typography>
      </div>
    </div>
  );
};

interface MenuProps {
  ranking: string;
}
export function Menu({ ranking }: MenuProps) {
  const classes = useStyles();
  const { text } = useText();
  const navigator = useNavigate();
  const [isShown, setIsShown] = React.useState(false);
  const [isCashShown, setIsCashShown] = React.useState(false);
  const [value, setValue] = React.useState(0);
  const location = useLocation();
  const [isFidelityShown, setIsFidelityShown] = React.useState(false);
  React.useEffect(() => {
    if (location.pathname.includes("tracking")) {
      setValue(1);
    } else if (location.pathname.includes("catalog")) {
      setValue(2);
    } else if (location.pathname.includes("history") && !location.pathname.includes("fidelity/history")) {
      setValue(3);
    } else if (location.pathname.includes("gift")) {
      setValue(4);
    } else if (location.pathname.includes("cash")) {
      setValue(5);
    } else if (location.pathname.includes("fidelity")) {
      setValue(6);
    } else {
      setValue(0);
    }
  }, [location.pathname, value]);

  const navigateToCashPage = () => {
    navigator("/cash/recap");
    setIsShown(false);
  };

  const navigateToRemittance = () => {
    navigator("/cash/remittance");
    setIsShown(false);
  };

  const navigateToFidelityPage = (e: any) => {
    navigator("/fidelity/advantages", { replace: true });
    setIsFidelityShown(false);
    e.stopPropagation();
  };
  const navigateToFidelityProgramPage = (e: any) => {
    navigator("fidelity/programs");
    setIsFidelityShown(false);
  };
  const navigateToFidelityProgramHistory = (e: any) => {
    navigator("/fidelity/history");
    fidelityShownClose();
    e.stopPropagation();
  };
  const fidelityShownOpen = () => {
    setIsFidelityShown(true);
  };
  const fidelityShownClose = () => {
    setIsFidelityShown(false);
  };
  return (
    <div className={classes.root}>
      <ul className={classes.ulStyled}>
        <MenuItem onClick={() => navigator("/")}>
          <GroupMenu
            active={value === 0}
            icon={<DashIcon color={value === 0 ? "#38c0ea" : "#70748f"} />}
            title={text.all.home}
          />
        </MenuItem>
        <MenuItem>
          <GroupMenu
            onMouseEnter={() => setIsShown(true)}
            onMouseLeave={() => setIsShown(false)}
            active={value === 1}
            icon={<BoxNewIcon color={value === 1 ? "#38c0ea" : "#70748f"} />}
            title={text.all.tracking}
          />
          {isShown && (
            <div
              className={classes.itemsTracking}
              onMouseEnter={() => setIsShown(true)}
              onMouseLeave={() => setIsShown(false)}
            >
              <Grid className={classes.divContainerDropdown}>
                <div className={classes.divContainerUl}>
                  {process.env.REACT_APP_SAMA_PAPSER_DISABLED_CHECK === "false" && (
                    <MenuItem
                      onClick={() => {
                        navigator("/tracking/request");
                        setIsShown(false);
                      }}
                    >
                      <div className={classes.items}>
                        <span>{text.all.request}</span>
                        <ChevronRight />
                      </div>
                    </MenuItem>
                  )}
                  <MenuItem
                    onClick={() => {
                      navigator("/tracking/task");
                      setIsShown(false);
                    }}
                  >
                    <div className={classes.items}>
                      <span>{text.all.task}</span>
                      <ChevronRight />
                    </div>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigator("/tracking/parcels");
                      setIsShown(false);
                    }}
                  >
                    <div className={classes.items}>
                      <span>{text.all.parcels}</span>
                      <ChevronRight />
                    </div>
                  </MenuItem>
                </div>
              </Grid>
            </div>
          )}
        </MenuItem>

        {process.env.REACT_APP_PAPS_PRODUCTS_CHECK === "false" && (
          <MenuItem onClick={() => navigator("/catalog")}>
            <GroupMenu
              active={value === 2}
              icon={<BoxesIcon color={value === 2 ? "#38c0ea" : "#70748f"} />}
              title={text.all.catalog}
            />
          </MenuItem>
        )}
        <MenuItem onClick={() => navigator("/history")}>
          <GroupMenu
            active={value === 3}
            icon={<HistoryIcon color={value === 3 ? "#38c0ea" : "#70748f"} />}
            title={text.all.history}
          />
        </MenuItem>

        {process.env.REACT_APP_PAPS_GIFT === "true" && (
          <MenuItem onClick={() => navigator("/gifts")}>
            <GroupMenu
              active={value === 4}
              icon={<GiftIcon color={value === 4 ? "#38c0ea" : "#70748f"} />}
              title={text.all.gift}
            />
          </MenuItem>
        )}

        <MenuItem>
          <GroupMenu
            onMouseEnter={() => setIsCashShown(true)}
            onMouseLeave={() => setIsCashShown(false)}
            active={value === 5}
            icon={<BoxNewIcon color={value === 5 ? "#38c0ea" : "#70748f"} />}
            title="Cash"
          />
          {isCashShown && (
            <div
              className={classes.itemsCash}
              onMouseEnter={() => setIsCashShown(true)}
              onMouseLeave={() => setIsCashShown(false)}
            >
              <Grid className={classes.divContainerDropdown}>
                <div className={classes.divContainerUl}>
                  <MenuItem onClick={navigateToCashPage}>
                    <div className={classes.items}>
                      <span>Cash</span>
                      <ChevronRight />
                    </div>
                  </MenuItem>
                  <MenuItem onClick={navigateToRemittance}>
                    <div className={classes.items}>
                      <span>{text.cash_management.remittance}</span>
                      <ChevronRight />
                    </div>
                  </MenuItem>
                </div>
              </Grid>
            </div>
          )}
        </MenuItem>

        {process.env.REACT_APP_PAPS_FIDELITY_DISABLED_CHECK === "true" && (
          <MenuItem onClick={navigateToFidelityProgramPage}>
            <GroupMenu
              onMouseEnter={fidelityShownOpen}
              onMouseLeave={fidelityShownClose}
              active={value === 6}
              icon={<FidelityMenuIcon width={20} height={20} color={value === 6 ? "#38c0ea" : "#70748f"} />}
              title={text.fidelity_program.my_fidelity_program}
              isFidelity
            />
            {isFidelityShown && (
              <div className={classes.itemsFedelity} onMouseEnter={fidelityShownOpen} onMouseLeave={fidelityShownClose}>
                <Grid className={classes.divContainerDropdownLC}>
                  <div className={classes.divContainerUl}>
                    <MenuItem onClick={navigateToFidelityPage}>
                      <div className={classes.items}>
                        <span>{text.all.advantages}</span>
                        <ChevronRight />
                      </div>
                    </MenuItem>
                    <MenuItem onClick={navigateToFidelityProgramHistory}>
                      <div className={classes.items}>
                        <span>{text.all.history}</span>
                        <ChevronRight />
                      </div>
                    </MenuItem>
                  </div>
                </Grid>
              </div>
            )}
          </MenuItem>
        )}
      </ul>
    </div>
  );
}

export default Menu;
